import { PermissoesService } from './../../../service/usuario/permissoes.service';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ClienteService } from 'app/service/cliente/cliente.service';
import { ClienteModel } from 'app/model/cliente/cliente.model';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { UnidadeGestoraModel } from 'app/model/cliente/unidadegestora';
import { UnidadeGestoraService } from 'app/service/cliente/unidade-gestora.service';
import { DialogConfirmComponent } from 'app/components/dialog/dialog-confirm/dialog-confirm.component';

@Component({
  selector: 'app-unidade-gestora',
  templateUrl: './unidade-gestora.component.html',
  styleUrls: ['./unidade-gestora.component.scss']
})
export class UnidadeGestoraComponent implements OnInit {
  @ViewChild('categoryPaginator', { read: MatPaginator }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginatorUnidadeGestora: MatPaginator;
  @ViewChild(MatSort) sortUnidadeGestora: MatSort;
  paginatorLength = 0;
  @Input() clienteProp: ClienteModel;
  @Input() clientePropId: number;
  @Output() newItemEvent = new EventEmitter<string>();
  displayedColumnsUnidadeGesotora = ['descricao', 'sigla', 'acoes-unidade'];
  dataSource = new MatTableDataSource<any[]>([]);
  dataSourceUnidadeGestora = new MatTableDataSource<UnidadeGestoraModel>([]);
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  unidadegestora = {} as UnidadeGestoraModel;
  unidadegestoras: UnidadeGestoraModel[];
  loading = false;
  isChecked = false;
  unidadeGestoraReady = false;

  clientes: ClienteModel[];

  public submit = false;

  public formUnidadeGestora: FormGroup;

  private page: ResponsePageable;

  public pageAtual = 0;

  public edited = false;
  public editado = false;
  public errorAlert = false;
  public successDelete = false;
  public messageError = false;
  mensagemErro;

  public arrayString: string;
  public creatorUnidadeGestora = false;
  public editorUnidadeGestora = false;
  public listaUnidadeGestora = false;
  public deletaUnidadeGestora = false;
  public superUser = false;

  public clienteId: any;
  public deData: CryptoJS.lib.WordArray;

  constructor(
    public unidadeGestoraService: UnidadeGestoraService,
    public clienteService: ClienteService,
    private _snackBar: MatSnackBar,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private permissionService: PermissoesService) {
    this.route.params.subscribe(params => this.clienteId = params['id']);
    this.deData = CryptoJS.AES.decrypt(decodeURIComponent(this.clienteId), 'pcdoc');
    this.clienteId = JSON.parse(this.deData.toString(CryptoJS.enc.Utf8));
  }

  ngOnInit() {
    this.formUnidadeGestora = this.fb.group({
      descricao: [null, [Validators.maxLength(80)]],
      sigla: [null, [Validators.maxLength(80)]],
      cliente: [null]
    });

    this.getUnidadeGestoraIdCliente(this.clienteId);
    this.getAuthority();
  }

  addNewItem(value: string) {
    this.newItemEvent.emit(value);
  }


  aplicarFiltros(filter: string) {
    filter = filter.trim();
    filter = filter.toLowerCase();
    this.dataSource.filter = filter;
  }

  aplicarFiltrosUnidadeGestora(filter: string) {
    filter = filter.trim();
    filter = filter.toLowerCase();
    this.dataSourceUnidadeGestora.filter = filter;
  }

  listarPageUnidadeGestora(page, size) {
    this.unidadeGestoraService.getPageUnidadeGestora(page, size).subscribe(res => {
      this.page = res;
      this.unidadegestoras = this.page.content;
    });
    this.unidadeGestoraReady = true;
  }

  getUnidadeGestoraIdCliente(id: number) {
    this.unidadeGestoraService.getUnidadeGestoraIdCliente(id).subscribe(data => {
      this.unidadegestoras = data;
      this.dataSourceUnidadeGestora = new MatTableDataSource(this.unidadegestoras);
      this.dataSourceUnidadeGestora.paginator = this.paginatorUnidadeGestora;
      this.dataSourceUnidadeGestora.sort = this.sortUnidadeGestora;
    }, error => {
      console.error(error);
    });
  }

  changePage(event) {
    this.listarPageUnidadeGestora(event.page, event.size);
    this.pageAtual = event.page;
  }

  onSubmit() {
    this.submit = true;
  }

  postSubmit() {
    this.submit = false;
  }

  saveOrEditUnidadeGestora() {
    if (this.unidadegestora.id !== undefined) {
      this.editUnidadeGestora();
    } else {
      this.adicionarUnidadeGestora();
    }
  }

  adicionarUnidadeGestora() {
    this.formUnidadeGestora.get('cliente').setValue(this.clienteProp);
    this.unidadeGestoraService.postUnidadeGestora(this.formUnidadeGestora.value, this.clientePropId).subscribe(area => {
      this.unidadegestora = new UnidadeGestoraModel();
      this.getUnidadeGestoraIdCliente(this.clientePropId);
      this.formUnidadeGestora.reset();
      this.openSnackBarSuccess('Unidade gestora salva com sucesso !');
      this.postSubmit();
    }, error => {
      if (error.status === 400) {
        this.mensagemErro = 'Preencha todos os campos obrigatórios!';
        this.openSnackBarError('Erro ao tentar salvar a Unidade gestora !');
      } else {
        this.mensagemErro = error.error.message;
        this.openSnackBarError(`Erro ao tentar salvar a Unidade gestora !`);
        console.log(this.mensagemErro);
      }

    });
  }

  editUnidadeGestora() {
    this.unidadeGestoraService.putUnidadeGestora(this.unidadegestora).subscribe(data => {
      this.getUnidadeGestoraIdCliente(this.clientePropId);
      this.openSnackBarSuccess('Unidade gestora atualizada com sucesso !');
    }, err => {
      this.mensagemErro = err.error.message;
      this.openSnackBarError(`Erro ao tentar atualizar a Unidade gestora !`);
    });
  }


  clickNovaUnidadeGestora() {
    this.unidadegestora.id = undefined;
    this.postSubmit();
    this.formUnidadeGestora.reset();
    this.formUnidadeGestora.get('descricao').setValue('');
    this.formUnidadeGestora.get('cliente').setValue('');
  }

  getDadosUnidadeGestoraEdit(unidadeGestora: UnidadeGestoraModel) {
    this.unidadegestora = { ...unidadeGestora };
    this.formUnidadeGestora.get('descricao').setValue(unidadeGestora.descricao);
    this.formUnidadeGestora.get('sigla').setValue(unidadeGestora.sigla);

  }

  confirmeExclusao(unidadegestoraDelete: UnidadeGestoraModel) {
    // const confirme = confirm('Deseja excluir esta Unidade gestora ?');
    // if (confirme === true) {
    //   this.deleteUnidadeGestora(id);
    // } else {
    //   console.log('Cancelou exclusão!');
    // }
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {name: 'Deseja excluir esta Unidade gestora (' + unidadegestoraDelete.descricao + ') ?',
      from: 'unidade-gestora.component.ts'}
    });

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      console.log(confirmed.apagar);
      if (confirmed.apagar === true) {
        this.deleteUnidadeGestora(unidadegestoraDelete.id);
      }
    });
  }


  deleteUnidadeGestora(id: number) {
    this.unidadeGestoraService.deleteUnidadeGestora(id).subscribe(area => {
      this.unidadegestoras.splice(1, id);
      if (this.unidadegestoras.length === 1) {
        this.getUnidadeGestoraIdCliente(this.clientePropId);
      }
      this.openSnackBarSuccess('Unidade gestora excluída com sucesso !');
    }, err => {
      // tslint:disable-next-line: one-line
      if (err.status === 500) {
        this.openSnackBarError('Erro ao tentar excluir a Unidade gestora !');
      }
      console.log(err);
    });
  }

  getAuthority() {
    this.getItemAuthority('authority');
    if (this.arrayString.includes('ADD_EMPRESA')) {
      this.creatorUnidadeGestora = true;
    }
    if (this.arrayString.includes('EDIT_EMPRESA')) {
      this.editorUnidadeGestora = true;
    }
    if (this.arrayString.includes('LIST_EMPRESA')) {
      this.listaUnidadeGestora = true;
    }
    if (this.arrayString.includes('DELETE_EMPRESA')) {
      this.deletaUnidadeGestora = true;
    }
    if (this.arrayString.includes('SUPER_USER')) {
      this.superUser = true;
    }
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
      try {
        const bytes = CryptoJS.AES.decrypt(
          store,
          sessionStorage.getItem('ticket-ECM')
        );
        this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return this.arrayString;
      } catch (e) {
        sessionStorage.clear();
      }
    }

    return null;
  }


  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/cliente-components/unidade-gestora/unidade-gestora.component.ts